import { ProductVariant2 } from '@/models/Product'
import { get } from '@/utils/axios'

import { transformProductVariants } from '../helpers/product'

const fetchProductVariantsByCatalogueId = async (
    catalogueIds: number[],
    latLng: string,
    vendorId?: string
) => {
    try {
        const results = await get<ProductVariant2[]>(
            `/hyperlocal/v1/product-variant/catalog`,
            {
                latLng,
                catalog_ids: catalogueIds.join(','),
                vendor_id: vendorId,
            }
        )
        return transformProductVariants(results)
    } catch {
        return []
    }
}

export default fetchProductVariantsByCatalogueId
